import api from "@/services/api/exercise/api-questions"
import QuestionItem from "@/app/exercise/components/question/core/models/questionModel"

export default class TrainingService {
  constructor(authSvc) {
    this.authSvc = authSvc
  }

  async list(query) {
    try {
      let res = await api.list(query)
      const {page = 1} = query;
      if(!res.results) throw new Error('Something went wrong and questions are not loading. Please, reload page or try again later.')
      let data = {
        results: res.results.map( item => { 
          item.page = page; 
          return new QuestionItem(item); 
        }),
        pagination: {
          count: res.count,
          next: res.next,
          previous: res.previous
        }
      }
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }
  
  async getPage(query, questionId) {
    try {
      return await api.getPage(query, questionId)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async find(ID) {
    try {
      let res = await api.find(ID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async get(ID) {
    try {
      let res = await api.get(ID)
      return new QuestionItem(res);
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async remove(item) {
    try {
      let res = await api.remove(item.id)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

}
